export type PromiseContext = {
  isCancelled: boolean
};

let activePromises: Array<PromiseContext> = [];

export function getPromiseContext(isCancelable: boolean): PromiseContext {
  const context = {
    isCancelled: false
  };

  if (isCancelable) {
    activePromises.push(context);
  }

  return context;
}

export function cancelAllCancelablePromises(): void {
  activePromises.forEach((context) => {
    context.isCancelled = true;
  });

  activePromises = [];
}
